module.exports = __webpack_public_path__ + "img/body-1.9b459839.jpg";